<template>
  <div>
    <div class="m-3 card" v-if="hasEditRights && !isNew && !isLockedForEdit">
      <div class="card-header">
        <h5 class="card-title">{{ $t("participants") }}</h5>
      </div>

      <div class="card-body">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          @click="goToExportTemplate"
          v-bind:disabled="participantsExporting"
        >
          <i
            v-if="participantsExporting"
            class="fa fa-spinner fa-pulse fa-fw"
          ></i>
          {{ $t("buttons.exportTemplate.btnText") }}
        </button>
        <label>
          <input type="checkbox" id="exportWithData" class="checkbox" />
          <span>{{ $t("checkboxes.exportWithData.cbText") }}</span>
        </label>
        <button
          v-if="canWrite"
          type="button"
          class="btn btn-primary btn-lg"
          @click="selectImportFiles"
          v-bind:disabled="participantsImporting"
        >
          <i
            v-if="participantsImporting"
            class="fa fa-spinner fa-pulse fa-fw"
          ></i>
          {{ $t("buttons.importFromExcel.btnText") }}
        </button>
        <input
          v-if="canWrite"
          type="file"
          id="importFile"
          class="selectFile"
          @change="goToImportFromExcel"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "participants-import",
  components: {},
  created: function () {},
  props: {
    registerId: {
      type: [Number, String],
      required: true,
    },
    entryId: {
      type: [Number, String],
    },
    canWrite: {
      type: Boolean,
      default: false,
    },
    isLockedForEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      participantsImporting: false,
      participantsExporting: false,
    };
  },
  methods: {
    selectImportFiles() {
      var dialog = $("#importFile");
      dialog.trigger("click");
    },
    goToImportFromExcel(args) {
      this.participantsImporting = true;

      var $input = $("#importFile")[0];
      var files = $input.files;
      if (files && files.length > 0) {
        var filename = files[0].name;
        var file = files[0];

        // clear the selected file so that the change event triggers when the same file is selected
        $input.value = null;

        var formData = new FormData();
        formData.append("FileName", filename);
        formData.append("FileContent", file);
        formData.append("RegisterId", this.registerId);
        formData.append("RegisterEntityId", this.entryId);

        this.$http
          .post("/api/participant/importParticipants", formData)
          .then((response) => {
            this.participantsImporting = false;
            if (response.data.hasErrors) {
              this.$vs.notify({
                title: this.$t("request.response.status.400"),
                text:
                  this.$t("invalidAction") +
                  " " +
                  this.$t("seeDownloadedFile") +
                  ' "Errors.txt"',
                color: "danger",
                time: this.$store.getters.notificationLongDuration,
              });

              this.$emit("imported");

              const blob = new Blob([response.data.data]);
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Errors.txt"); // or any other extension
              document.body.appendChild(link);
              link.click();

              return;
            }

            if (response.data.moodleSyncError) {
              this.$vs.notify({
                title: this.$t(
                  "request.response.status." +
                    this.$helpers.responseStatusCode(response)
                ),
                text:
                  this.$helpers.responseMessage(response) +
                  " " +
                  this.$t("seeDownloadedFile") +
                  ' "Errors.txt"',
                color: "warning",
                time: this.$store.getters.notificationLongDuration,
              });

              this.$emit("imported");

              const blob = new Blob([response.data.data]);
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Errors.txt"); // or any other extension
              document.body.appendChild(link);
              link.click();

              return;
            }

            this.$vs.notify({
              title: this.$t(
                "request.response.status." +
                  this.$helpers.responseStatusCode(response)
              ),
              text: this.$helpers.responseMessage(response),
              color: "success",
              time: this.$store.getters.notificationLongDuration,
            });
          })
          .catch((error) => {
            this.participantsImporting = false;
            this.$vs.notify({
              title: this.$t(
                "request.response.status." +
                  this.$helpers.errorStatusCode(error)
              ),
              text: this.$helpers.errorText(error),
              color: "danger",
              time: this.$store.getters.notificationLongDuration,
            });
          });
      }
    },
    goToExportTemplate() {
      this.participantsExporting = true;

      const registerEntityId = this.entryId;
      var $exportCheckbox = $("#exportWithData");
      var withData = $exportCheckbox.is(":checked");

      this.$http
        .get(
          `/api/participant/exportParticipantsTemplate/${registerEntityId}/${withData}`,
          {
            // parameters: {
            //     registerEntityId: this.entryId,
            //     withData: true
            // },
            responseType: "blob",
          }
        )
        .then((response) => {
          this.participantsExporting = false;

          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Participants.xlsx"); // or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.participantsExporting = true;

          this.$vs.notify({
            title: this.$t(
              "request.response.status." + this.$helpers.errorStatusCode(error)
            ),
            text: this.$helpers.errorText(error),
            color: "danger",
            time: this.$store.getters.notificationDuration,
          });
        });
    },
  },
  mounted() {},
  computed: {
    isNew() {
      return this.entryId === undefined || this.entryId <= 0;
    },
    isEnVersion() {
      return this.$store.getters.currentCulture === "en";
    },
    hasEditRights() {
      return true;
    },
  },
};
</script>


<style>
</style>
